/* =========================================================
   LIQUID GLASS estilo iPhone
   1) Filtros SVG que REFRACTAN (deforman) lo que hay detrás del vidrio
   2) Lente de vidrio líquido que sigue al cursor y deforma la página
   3) El vidrio del menú y las etiquetas "fluye" como agua
   Refracción real: Chrome / Edge / Brave (computadora).
   Safari / Firefox / celulares: versión con desenfoque + animaciones CSS.
   ========================================================= */
(function () {
  var ua = navigator.userAgent;
  var isChromium = /Chrome\/|Chromium\//.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = false; // se ve igual aunque el PC tenga las animaciones apagadas
  if (reduce) return;

  // ---------- Mapa de desplazamiento para la lente (bordes que doblan la luz) ----------
  function lensMap(size) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var ctx = c.getContext('2d'); var img = ctx.createImageData(size, size); var d = img.data;
    for (var y = 0; y < size; y++) {
      for (var x = 0; x < size; x++) {
        var nx = (x / (size - 1)) * 2 - 1, ny = (y / (size - 1)) * 2 - 1;
        var r = Math.sqrt(nx * nx + ny * ny);
        var i = (y * size + x) * 4;
        var rr = 128, gg = 128;
        if (r < 1) {
          // refracción fuerte en el borde, centro casi limpio (como una gota de vidrio)
          var edge = Math.pow(r, 3);
          rr = 128 - nx * 127 * edge;
          gg = 128 - ny * 127 * edge;
        }
        d[i] = rr; d[i + 1] = gg; d[i + 2] = 128; d[i + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    return c.toDataURL();
  }

  if (isChromium) {
    var svgNS = 'http://www.w3.org/2000/svg';
    var holder = document.createElement('div');
    holder.setAttribute('aria-hidden', 'true');
    holder.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    holder.innerHTML =
      '<svg xmlns="' + svgNS + '" width="0" height="0">' +
        // Vidrio que fluye: ondas lentas que deforman el fondo
        '<filter id="lg-flow" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.012 0.018" numOctaves="2" seed="7" result="noise"/>' +
          '<feGaussianBlur in="noise" stdDeviation="2.5" result="soft"/>' +
          '<feDisplacementMap in="SourceGraphic" in2="soft" scale="38" xChannelSelector="R" yChannelSelector="G" result="disp"/>' +
          '<feGaussianBlur in="disp" stdDeviation="1.2"/>' +
        '</filter>' +
        // Lente: dobla la luz en los bordes como una gota
        '<filter id="lg-lens" x="0" y="0" width="1" height="1" primitiveUnits="objectBoundingBox" color-interpolation-filters="sRGB">' +
          '<feImage href="' + lensMap(128) + '" x="0" y="0" width="1" height="1" preserveAspectRatio="none" result="map"/>' +
          '<feDisplacementMap in="SourceGraphic" in2="map" scale="0.32" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter>' +
      '</svg>';
    document.body.appendChild(holder);
    document.documentElement.classList.add('lg-refract');
  }

  if (!fine) return;

  // ---------- Lente de vidrio líquido que sigue al cursor ----------
  var lens = document.createElement('div');
  lens.className = 'lg-lens';
  lens.setAttribute('aria-hidden', 'true');
  lens.innerHTML = '<span class="lg-lens-shine"></span>';
  document.body.appendChild(lens);

  var pos = { x: -200, y: -200 }, cur = { x: -200, y: -200 }, vel = { x: 0, y: 0 };
  var size = 1, sizeT = 1, sizeV = 0;
  var stretch = 0, stretchV = 0, angle = 0;
  var visible = false, last = performance.now();

  window.addEventListener('pointermove', function (e) {
    pos.x = e.clientX; pos.y = e.clientY;
    if (!visible) { cur.x = pos.x; cur.y = pos.y; visible = true; lens.classList.add('is-on'); }
    var t = e.target;
    if (t.closest && t.closest('input, textarea, select')) sizeT = 0.35;
    else if (t.closest && t.closest('a, button, summary, .is-tilt')) sizeT = 1.45;
    else sizeT = 1;
  }, { passive: true });
  document.addEventListener('pointerleave', function () { visible = false; lens.classList.remove('is-on'); });
  window.addEventListener('blur', function () { visible = false; lens.classList.remove('is-on'); });
  window.addEventListener('pointerdown', function () { sizeV -= 6; });

  function frame(now) {
    var dt = Math.min(0.032, (now - last) / 1000); last = now;
    // posición con resorte (se siente "líquida", con un poco de arrastre)
    var k = 120, d = 16;
    vel.x += (-(cur.x - pos.x) * k - vel.x * d) * dt;
    vel.y += (-(cur.y - pos.y) * k - vel.y * d) * dt;
    cur.x += vel.x * dt; cur.y += vel.y * dt;
    // tamaño con rebote
    sizeV += (-(size - sizeT) * 180 - sizeV * 14) * dt; size += sizeV * dt;
    // se estira en la dirección del movimiento y tiembla al frenar (gelatina)
    var speed = Math.sqrt(vel.x * vel.x + vel.y * vel.y);
    var st = Math.min(0.45, speed / 2600);
    stretchV += (-(stretch - st) * 260 - stretchV * 10) * dt; stretch += stretchV * dt;
    if (speed > 40) angle = Math.atan2(vel.y, vel.x) * 180 / Math.PI;
    lens.style.transform =
      'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0) translate(-50%,-50%) ' +
      'rotate(' + angle.toFixed(1) + 'deg) scale(' + (size * (1 + stretch)).toFixed(3) + ',' + (size * (1 - stretch * 0.55)).toFixed(3) + ') rotate(' + (-angle).toFixed(1) + 'deg)';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
